<template>
    <div id="content">
        <div id="search" class="bg-light rounded d-block">
            <b-form @submit.prevent.stop="onSearch" @reset="onSearchReset" inline>
                <b-form-select class="mb-2 mr-sm-2 mb-sm-0 form-control form-control-sm" :options="this.city"
                               v-model="search.city"></b-form-select>
                <b-form-select class="mb-2 mr-sm-2 mb-sm-0 form-control form-control-sm" :options="this.vehicleCategory"
                               v-model="search.category"></b-form-select>
                <b-form-select class="mb-2 mr-sm-2 mb-sm-0 form-control form-control-sm" :options="this.vehicleLevel"
                               v-model="search.level"></b-form-select>
                <b-form-select class="mb-2 mr-sm-2 mb-sm-0 form-control form-control-sm" :options="this.status"
                               v-model="search.status"></b-form-select>
                <b-form-checkbox class="mb-2 mr-sm-2 mb-sm-0" v-model="search.active">is Active</b-form-checkbox>
                <div class="ml-auto">
                    <b-button type="reset" class="mb-2 mr-sm-2 mb-sm-0">Reset</b-button>
                    <b-button type="submit" variant="primary" class="mb-2 mb-sm-0" :disabled="loading">Search</b-button>
                </div>
            </b-form>
        </div>

        <loader v-if="loading"></loader>
        <div id="list" v-else>
            <div v-if="data.data.length > 0">
                <b-table small striped hover :items="data.data" :fields="search.fields">

                    <template v-slot:cell(id)="data">
                        <router-link :to="{ name: 'tripDetail', params: { id: data.value }}">{{data.value}}</router-link>
                    </template>

                    <template v-slot:cell(active)="data">
                        <b-icon scale="5" v-if="data.value" icon="dot" variant="success"></b-icon>
                        <b-icon scale="5" v-else icon="dot" variant="secondary"></b-icon>
                    </template>

                    <template v-slot:cell(user)="data">
                        <router-link :to="{ name: 'userDetail', params: { id: data.value.id }}">{{data.value.name}} {{data.value.surname}}</router-link>
                    </template>

                    <template v-slot:cell(driver)="data">
                        <router-link :to="{ name: 'userDetail', params: { id: data.value.id }}">{{data.value.name}} {{data.value.surname}}</router-link>
                    </template>

                    <template v-slot:cell(status)="data">
                        <span class="badge badge-success">{{data.value}}</span>
                    </template>

                    <template v-slot:cell(city)="data">
                        {{data.value.name}}
                    </template>

                    <template v-slot:cell(category)="data">
                        {{data.value.name}}
                    </template>

                    <template v-slot:cell(level)="data">
                        {{data.value.name}}
                    </template>

                    <template v-slot:cell(payment)="data">
                        {{data.value.price}}₺
                    </template>

                    <template v-slot:cell(createdAt)="data">
                        {{ data.value | moment("MMMM Do YYYY HH:mm:ss") }}
                    </template>
                </b-table>
                <div class="ml-auto">
                    <b-pagination
                            @change="setPage"
                            :disabled="loading"
                            align="right"
                            v-model="data.page"
                            :total-rows="data.total"
                            :per-page="search.perPage"
                    ></b-pagination>
                </div>
            </div>

            <div class="card text-center" v-else>
                <div class="card-body">
                    <h5 class="card-title">Search Result</h5>
                    <p class="card-text">No Data</p>
                    <b-button @click="onSearchReset" variant="primary">Reset</b-button>
                </div>
                <div class="card-footer text-muted">
                    {{JSON.stringify(search)}}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ContentLoader from '../../../../components/ContentLoader';
    import GetTrips from '../../../../store/actions/getTrips';
    import ShowError from '../../../../helpers/showError';

    export default {
        name: 'UserTrips',
        components: {
            loader: ContentLoader,
        },
        created() {
            this.onSearch();
        },
        data() {
            return {
                data: {
                    data: []
                },
                loading: true,
                city: this.$store.state.city.map(item => ({text: item.name, value: item.id})),
                vehicleLevel: this.$store.state.vehicleLevel.map(item => ({text: item.name, value: item.id})),
                vehicleCategory: this.$store.state.vehicleCategory.map(item => ({text: item.name, value: item.id})),
                status: [
                    'REQUESTED',
                    'DRIVER_REQUESTED',
                    'DRIVER_ACCEPTED',
                    'DRIVER_ARRIVING',
                    'ON_TRIP',
                    'FINISHED',
                    'PAYMENT_ISSUE',
                    'DRIVER_REJECTED',
                    'USER_CANCELLED',
                    'DRIVER_CANCELLED',
                    'NO_NEAR_DRIVER',
                    'UNKNOWN_ERROR'
                ],
                search: {
                    perPage: 30,
                    page: 0,
                    userId: this.$route.params.id,
                    city: undefined,
                    category: undefined,
                    level: undefined,
                    status: undefined,
                    active: null,
                    fields: ['id', 'active', 'user', 'driver', 'status', 'city', 'category', 'level', 'payment', 'createdAt']
                }
            }
        },
        methods: {
            setPage(page) {
                this.search.page = page;
                this.onSearch();
            },
            async onSearch() {
                try {
                    this.loading = true;
                    this.data = await GetTrips(this.search);
                } catch (e) {
                    ShowError(this, e);
                } finally {
                    this.loading = false;
                }
            },
            onSearchReset() {
                this.search = {
                    perPage: 30,
                    page: 0,
                    userId: this.$route.params.id,
                    city: undefined,
                    category: undefined,
                    level: undefined,
                    status: undefined,
                    active: null,
                    fields: this.search.fields
                };
                this.onSearch();
            }
        }
    }
</script>


<style scoped>
    #search {
        margin: 10px 0;
        padding: 10px;
    }
</style>
